import { defineMessages, type IntlShape } from 'react-intl';
import logError from '@alltrails/core/utils/logError';
import type TrailFeature from '@alltrails/types/TrailFeature';

// Some strings are in the type but no longer used, like 'ada', which is now part of TrailSuitability. Leave blank to trigger error if they pop up.
// If we happen to need one, feel free to add it, that should cause no issues.
type MessageKey = Exclude<TrailFeature, 'ada' | 'dogs-leash' | 'dogs-no' | 'kids' | 'partially-paved' | 'paved' | 'strollers'>;
const messages = defineMessages<MessageKey>({
  beach: { defaultMessage: 'Beaches' },
  cave: { defaultMessage: 'Caves' },
  'city-walk': { defaultMessage: 'City walks' },
  dogs: { defaultMessage: 'Dog-friendly' },
  event: { defaultMessage: 'Events' },
  forest: { defaultMessage: 'Forests' },
  'historic-site': { defaultMessage: 'Historic sites' },
  'hot-springs': { defaultMessage: 'Hot springs' },
  lake: { defaultMessage: 'Lakes' },
  'pub-crawl': { defaultMessage: 'Pub walks' },
  'rails-trails': { defaultMessage: 'Rail trails' },
  river: { defaultMessage: 'Rivers' },
  views: { defaultMessage: 'Views' },
  waterfall: { defaultMessage: 'Waterfalls' },
  'wild-flowers': { defaultMessage: 'Wildflowers' },
  wildlife: { defaultMessage: 'Wildlife' }
});

export default function getTrailFeatureLabel(intl: IntlShape, feature: TrailFeature): string {
  const message = messages[feature];

  if (message) {
    return intl.formatMessage(message);
  }

  logError(new Error(`Unknown feature: ${feature}`));
  return '';
}
